// 公共文案
const COMMON = {
  common_thinking: '开始思考',
  common_Generating: '生成中...',
  common_Better: '更好',
  common_Same: '相同',
  common_Worse: '更差',
  common_Stop: '停止',
  common_Submit: '提交',
  common_Cancel: '取消',
  common_Confirm: '确认',
  common_Copy: '复制',
  common_Copied: '已复制',
  common_Email: '邮箱',
  common_Edit: '编辑',
  common_Delete: '删除',
  common_Built_by_Tate_A_Tate: '使用拓问平台创建'
};

const SKILL = {
  skill_File_Knowledge: '文件知识',
  skill_Web_Knowledge: '网络知识',
  skill_Prior_Knowledge: '先验知识',
  skill_Workflow: '工作流程',
  skill_API_Development: 'API开发',
  skill_Custom_Code: '自定义代码',
  skill_Remote_MCP: '远程MCP'
};

// 请求错误
const REQUEST_ERROR = {
  request_Please_change_a_topic: '请更换话题', // 回答命中敏感词提示
  request_Error_occurred: '发生错误', // 消息错误
  request_system_request_error: '系统请求异常', // 系统请求异常
  request_no_permission: '当前操作没有权限', // 当前操作没有权限
  request_Please_check_your_question: '请检查您的问题', // 问题命中敏感词报错
  request_access_resource_does_not_exist: '访问资源不存在', // 访问资源不存在
  request_Error_occurred_stopped_generated: '发生错误，已停止生成', // 消息生成错误，工作流报错
  request_unknown_system_error: '系统未知错误，请反馈给管理员', // 系统未知错误，请反馈给管理员
  request_authentication_failed: '认证失败，无法访问系统资源' // 认证失败，无法访问系统资源
};

// 聊天机器人列表
const CHAT_BOT_LIST = {
  chat_Like: '点赞',
  chat_Source: '来源',
  chat_Dislike: '点踩',
  chat_Read_aloud: '语音播放', // 语音播放
  chat_Regenerate: '重新生成', // 重新生成
  chat_Shared_link: '分享链接',
  chat_Reached_limits: '已达上限', // 重新生成 - 已达上限
  chat_Guide_questions: '猜你想问',
  chat_Already_new_chat: '已经为新会话', // 已经为新会话
  chat_Rate_this_answer: '评价此回答', // 重新生成 - 评价
  chat_Stopped_generated: '已停止生成', // 停止生成
  chat_Developer_process: '开发者模式', // 开发者模式
  chat_Feedback_cancelled: '已取消反馈', // 回答取消点赞
  chat_Reason_of_disliking: '点踩原因', // 点踩 - 反馈标题
  chat_Message_your_question: '输入您的问题',
  chat_Question_templates: '问题模板', // 快捷指令
  chat_Thanks_for_your_support: '感谢您的支持', // 回答点赞
  chat_Text_content_is_required: '文本内容不能为空',
  chat_Thanks_for_your_feedback: '感谢您的反馈',
  chat_Message_your_question_or_drag_to_upload: '输入您的问题或拖拽上传文件',
  chat_Thanks_for_your_feedback_We_will: '感谢您的反馈！我们将查看并改进。',
  chat_Optional_Please_tell_us_more_about_your_experience: '(可选) 请告诉我们更多关于您的体验',
  chat_Wrong_answer: '回答错误',
  chat_Does_not_understand_my_question: '不理解我的问题',
  chat_Typos: '拼写错误',
  chat_Incorrect_facts: '事实错误',
  chat_Blank_answer: '空白回答',
  chat_Lack_of_professionalism: '缺乏专业性',
  chat_Context_is_not_understood: '不理解上下文',
  chat_Illegal_content: '非法内容',
  chat_Others: '其他',
  chat_Delete_chat_permanently: '永久删除会话',
  chat_Delete_chat_permanently_confirm: '删除后，对话内容将无法恢复。确定删除吗？?'
};

// 菜单
const MENU = {
  menu_Today: '今天',
  menu_new_chat: '新聊天',
  menu_Logged_in: '已登录',
  menu_Yesterday: '昨天',
  menu_Last_7_days: '近7天',
  menu_No_chat_yet: '暂无聊天记录',
  menu_Subscription: '订阅',
  menu_chat_History: '聊天历史',
  menu_please_log_in: '请登录',
  menu_Anonymous_user: '匿名用户',
  menu_See_more_history_chats: '查看更多历史聊天',
  menu_Retain_7_day_chat_history: '保留7天聊天记录'
};

// 文件上传
const UPLOAD = {
  upload_Incorrect_format: '格式不正确',
  upload_Files_cannot_exceed: '文件大小不能超过 {number}MB',
  upload_Images_cannot_exceed: '图片大小不能超过 {number}MB',
  upload_Drag_and_drop_here_to_upload: '拖拽文件到此处上传',
  upload_No_more_than_imgs: '最多上传 {number} 张图片',
  upload_No_more_than_file: '最多上传 {number} 个文件',
  upload_Upload_failed: '{name} 上传失败，请稍后重试',
  upload_Upload_failed_empty: '上传失败，文件内容为空',
  upload_Once_upload_up_to_fileListLimit_attachments: '单次最多上传 {fileListLimit} 个附件',
  upload_file: '文件：最多 {fileListLimit} 个 (DOC/DOCX/PDF/TXT，每个不超过 {FILE_SIZE}MB)',
  upload_img: '图片：最多 {imgListLimit} 张 (JPEG/JPG/PNG，每个不超过 {IMG_SIZE}MB)',
  upload_img_file: '图片：最多 {imgListLimit} 张 (JPEG/JPG/PNG，每个不超过 {IMG_SIZE}MB)\n文件：最多 {fileListLimit} 个 (DOC/DOCX/PDF/TXT，每个不超过 {FILE_SIZE}MB)'
};

// 登录
const LOGIN = {
  login_and: '及',
  login_OR: '或',
  login_Log_out: '退出登录',
  login_Welcome_to: '欢迎使用{name}',
  login_Login_success: '登录成功。',
  login_Log_out_success: '退出登录成功。',
  login_Privacy_Policy: '隐私政策',
  login_Terms_of_Service: '用户协议',
  login_Log_in_with_Google: '使用Google登录',
  login_Are_you_sure_to_log_out: '确定要退出登录吗？',
  login_By_logging_in_I_agree_with: '登录即表示同意',
  login_Please_enter_your_phone_number: '请输入手机号',
  login_Please_enter_your_phone_number_to_start_using: '请输入手机号码以开始使用',
  login_And_authorize_Tuowen_to_obtain_the_local_machine_number: '并授权拓问获得本机号码',
  login_Phone_Number: '手机号',
  login_Email: '邮箱',
  login_Code: '验证码',
  login_Please_enter_email_address: '请输入邮箱地址',
  login_Obtain_verification_code: '获取验证码',
  login_Resend_count: '重新发送 ({count}s)',
  login_Verification_code_has_been_sent: '验证码已发送',
  login_Please_enter_a_6_digit_verification_code: '请输入6位验证码',
  login_Register_Login: '注册 / 登录',
  login_Verification_failed: '验证失败',
  login_Please_complete_the_security_verification_first: '请先完成安全验证',
  login_Drag_the_slider_to_the_right_to_complete_verification: '向右拖动滑块完成验证'
};

// 申请
const APPLY = {
  apply_Reason: '申请原因',
  apply_User_name: '用户名',
  apply_Please_enter_the_reason: '请输入申请原因（最多500字符）',
  apply_You_need_to_apply_for_approval: '您需要申请审批才能使用此机器人。',
  apply_Submit_success: '提交成功',
  apply_The_administrator_will_review_your_application: '管理员将审核您的申请，请耐心等待',
  apply_Application_is_under_review: '申请审核中',
  apply_Application_failed: '申请失败',
  apply_The_administrator_has_rejected_your_application: '管理员已拒绝您的申请',
  apply_Account_disabled: '账户已禁用',
  apply_Your_account_has_been_disabled: '您的账户已被禁用，对此造成的不便我们深表歉意'
};

// 支付
const PAY = {
  pay_USD: '美元',
  pay_USD_month: '美元/月',
  pay_width_only: '仅需',
  pay_Unlock_Now: '立即解锁',
  pay_Subscribe_Now: '立即订阅',
  pay_Unlimited_usage_no_restrictions: '无限使用，无限制',
  pay_One_time_payment_no_subscriptions: '一次性支付，无订阅',
  pay_Instant_access_no_waiting: '即时访问，无需等待',
  pay_Continuous_updates_and_improvements: '持续更新和改进',
  pay_Flexible_cancellation_options: '灵活的取消选项',
  pay_Always_stay_up_to_date_with_the_latest_features: '始终使用最新功能',
  pay_Unlock_Unlimited_Access_to_the_Agent: '解锁代理的无限访问权限',
  pay_Get_Unlimited_Access_with_a_Flexible_Subscription: '通过灵活的订阅获得无限访问权限'
};

const MONTH = {
  Jan: '一月',
  Feb: '二月',
  Mar: '三月',
  Apr: '四月',
  May: '五月',
  Jun: '六月',
  Jul: '七月',
  Aug: '八月',
  Sep: '九月',
  Oct: '十月',
  Nov: '十一月',
  Dec: '十二月'
};

const FORM_VALIDATE = {
  validate_phone_null: '手机号不能为空',
  validate_phone_error: '手机号格式不正确',
  validate_code_null: '验证码不能为空',
  validate_code_error: '验证码错误',
  validate_email_error: '邮箱格式错误',
  validate_email_null: '邮箱不能为空'
};

const ERROR_PAGE = {
  error_Try_for_free: '免费体验',
  error_The_page_you_visited_is_currently_unavailable: '您访问的页面暂不可用。您可以访问平台官网以获取更多信息。',
  error_Tate_A_Tate_a_one_stop_agent_creation_platform: '拓问，一站式智能体创建平台。',
  error_achieve_AI_entrepreneurship_monetization: '无需编程基础,也能轻松实现AI创业变现。仅需5分钟,即可快速构建全栈智能体,助您从创意萌芽到全球盈利,完成一站式开发闭环。'
};

const THINK = {
  think_Thinking: '深度思考...',
  think_Show_thinking: '显示思考过程',
  think_Contains_sensitive_word_generation_stopped: '包含敏感词，生成已停止。'
};

export default {
  ...PAY,
  ...MENU,
  ...SKILL,
  ...MONTH,
  ...APPLY,
  ...LOGIN,
  ...THINK,
  ...COMMON,
  ...UPLOAD,
  ...ERROR_PAGE,
  ...REQUEST_ERROR,
  ...CHAT_BOT_LIST,
  ...FORM_VALIDATE
};
